export default "__VITE_ASSET__DTbt0$5B__"